import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

import CGV from "@/pages/CGV";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function BrandMeta() {
  useEffect(() => {
    // Forcer le titre et le favicon après que les scripts Emergent les aient écrasés
    const setMeta = () => {
      document.title = "ELLAA WEDDING \u2013 Wedding Planner Paris";
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.type = "image/png";
      link.href = "/favicon-ellaa.png";
    };
    setMeta();
    // Observer les changements de titre pour les réécraser si besoin
    const observer = new MutationObserver(() => {
      if (document.title !== "ELLAA WEDDING \u2013 Wedding Planner Paris") {
        document.title = "ELLAA WEDDING \u2013 Wedding Planner Paris";
      }
    });
    observer.observe(document.querySelector("title") || document.head, {
      subtree: true, childList: true, characterData: true
    });
    return () => observer.disconnect();
  }, []);
  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      <BrandMeta />
      <ScrollToTop />
      {!isAdmin && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/prestations" element={<Services />} />
        <Route path="/galerie" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      <Toaster position="bottom-center" toastOptions={{
        style: {
          background: '#3D1602',
          color: '#F7F3EA',
          border: '1px solid rgba(233,220,196,0.3)',
          borderRadius: '0',
          fontFamily: "'Inter', sans-serif",
          fontSize: '12px',
          letterSpacing: '1px',
        }
      }} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
